import { render, staticRenderFns } from "./glusterfs.vue?vue&type=template&id=2b7e0f76&"
import script from "./glusterfs.vue?vue&type=script&lang=js&"
export * from "./glusterfs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports